

interface BreakingNewsAlertProps {
  message: string;
  link: string;
  isVisible: boolean;
}

export default function BreakingNewsAlert({ message, link, isVisible }: BreakingNewsAlertProps) {
  return null;
}